import Head from 'next/head';
import Link from 'next/link';

import { DGGeneralCoupons } from '@/utils/constants/MetaData';

const General = () => {
  return (
    <>
      <Head>
        <title>{DGGeneralCoupons.metaTitle}</title>
        <meta name="description" content={DGGeneralCoupons.metaDescription} />
        <meta
          property="og:description"
          content={DGGeneralCoupons.metaOGDescription}
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">eSwarna Digital Gold Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Coupons
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <p className="loanCard__title text--bold text--black">Coupons</p>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <p className="text--black text--semi title">
                  What is the benefit of a eSwarna Digital Gold coupon?
                </p>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    eSwarna Digital Gold coupons may give customers a discount
                    on their overall eSwarna Digital Gold cart value or an
                    additional amount of gold at the time of purchase on the
                    Muthoot FinCorp ONE app. eSwarna Digital Gold coupons are an
                    alphanumeric code unique to each user and can be generated
                    on various employee engagement platform like Advantage Club.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  How do I redeem my eSwarna Digital Gold coupon?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can redeem your coupon at the checkout page of Muthoot
                    FinCorp ONE app while buying eSwarna Digital Gold.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  Where do I purchase the coupon code for eSwarna Digital Gold?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can purchase eSwarna Digital Gold coupons by simply
                    visiting external employee engagement platform like
                    Advantage Club to use the reward points accumulated in your
                    wallet. You can also buy a Muthoot FinCorp ONE eSwarna
                    Digital Gold coupon on these platforms to generate a unique
                    code to get the offer.
                    <br />
                    <br />
                    Once you have purchased your eSwarna Digital Gold coupon,
                    you can apply the same during check-out on the Muthoot
                    FinCorp ONE app while buying eSwarna Digital Gold.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  Are eSwarna Digital Gold coupons free?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    No, eSwarna Digital Gold coupons are not free, you can
                    purchase them using reward points or using cash from
                    external employee engagement platforms like Advantage Club
                    and Vantage Circle.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  Can eSwarna Digital Gold coupons be used more than once?
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    No, eSwarna Digital Gold coupons are for one-time use only
                    and each code is unique to every user.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  What&apos;s the validity of my eSwarna Digital Gold coupon?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Each eSwarna Digital Gold coupon is valid for a limited time
                    only and expires on the date specified in the voucher
                    section of the external employee engagement platform like
                    Advantage Club.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                <p className="text--black text--semi title">
                  What are the different denominations that can be redeemed
                  using coupons?
                </p>
              </div>
              <div
                id="collapseSeven"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The different denominations that can be redeemed using these
                    coupons are Rs. 200, Rs. 500, Rs. 1000 and Rs. 2000
                    (inclusive of tax) from the Muthoot FinCorp ONE app while
                    purchasing eSwarna Digital Gold.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingEight"
                data-toggle="collapse"
                data-target="#collapseEight"
                aria-expanded="false"
                aria-controls="collapseEight"
              >
                <p className="text--black text--semi title">
                  What is the offer on my first in-app purchase of eSwarna
                  Digital Gold?
                </p>
              </div>
              <div
                id="collapseEight"
                className="collapse"
                aria-labelledby="headingEight"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    As a first-time new user, you can get 2% extra up to Rs 200
                    on a minimum purchase of eSwarna Digital Gold worth Rs. 500.
                    - The extra gold will be credited to your eSwarna Digital
                    Gold wallet within 5 working days of your purchase.
                    <br />
                    <br />
                    This is a launch offer valid for a limited period of two
                    months and applicable to all new customers on the Muthoot
                    FinCorp ONE app.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingNine"
                data-toggle="collapse"
                data-target="#collapseNine"
                aria-expanded="false"
                aria-controls="collapseNine"
              >
                <p className="text--black text--semi title">
                  Where can I see my eSwarna Digital Gold coupon codes?
                </p>
              </div>
              <div
                id="collapseNine"
                className="collapse"
                aria-labelledby="headingNine"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can see your eSwarna Digital Gold coupon on the My
                    Vouchers section on the Advantage Club.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default General;
